import { useState, forwardRef,  useEffect, useCallback } from 'react';
import { useParams, useNavigate} from 'react-router-dom';
import { useForm, Controller, useFieldArray, Watch } from 'react-hook-form';
import { Tooltip } from 'react-tooltip';
import DataTable from 'react-data-table-component';
import DatosCabezaFamilia from '../Caracterizacion/DatosCabezaFamilia.jsx';
import apiService from './../../Auth/apiService.jsx';
import { toast } from 'react-toastify';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import { es } from 'date-fns/locale';
import MenuCaracterizacion from '../Caracterizacion/Componentes/MenuCaracterizacion.jsx';
import { useAuth } from './../../Auth/AuthContext.jsx';
import { BotonBorrar } from "./../Utils/BotonBorrar.jsx";
import SearchForm from './../Utils/Searchform.jsx';
import SeccionPageHeader from './../Utils/SeccionPageHeader.jsx';
import CargandoSpinner from './../Utils/CargandoSpinner.jsx';
import { FaCalendar } from 'react-icons/fa';

registerLocale('es', es);
setDefaultLocale('es');
import PropTypes from 'prop-types';
import { set } from 'date-fns';

const CustomInput = forwardRef(({ value, onClick }, ref) => (
        <button
            type="button"
            className="custom-input"
            onClick={onClick}
            ref={ref}
            aria-label="Seleccionar fecha"
            style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', padding: 0 }}
        >
            <input 
                value={value}
                readOnly 
                className='widthCalendar' 
                style={{ pointerEvents: 'none',
                background: '#fff',
                border: '1px solid #ced4da',
                padding: '6px 8px',
                borderRadius: 4,
                minWidth: 140,
                marginRight: 8, 
                }}
            />
            <FaCalendar size={20} color="black"/>
        </button>
        ));

CustomInput.propTypes = {
    value: PropTypes.string,
    onClick: PropTypes.func,
};

function BorrandoAtencion(row, Borraratencion){
    return (
        <div>
            <BotonBorrar Borrar={Borraratencion} row={row} />
        </div>
    );
}

export default function CrearAtencion(){
    const navigate = useNavigate();
    const [Cargando, setCargando] = useState(false);
    const { token, user, rol, sedeActual } = useAuth();
    const { idCabezaFamilia } = useParams();
    const { control, handleSubmit, register, setValue, watch, getValues, reset, formState: { errors }} = useForm();
    const { append, remove } = useFieldArray({
        control,
        name: 'atencionesfields'
      });
    const [entidades, setEntidades] = useState([]);
    const [ayudas, setAyudas] = useState([]);
    const [integrantes, setIntegrantes] = useState([]);
    const [sedes, setSedes] = useState([]);
    const [vulnerabilidades, setVulnerabilidades] = useState([]);
    const [estadoCasos, setEstadoCasos] = useState([]);
    const [modulosDdhh, setModulosDdhh] = useState([]);
    const [tiposReporteSeguimiento, setTiposReporteSeguimiento] = useState([]);
    const [motivosAtencion, setMotivosAtencion] = useState([]);
    const [tiposSeguimiento, setTiposSeguimiento] = useState([]);
    const [esSeguimiento, setEsSeguimiento] = useState(false);
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
        cab_nodeclaracion: ''
      });
    async function ValidarSiEsSeguimiento(idAyuda){
        setValue('intMotivoatencion', '');
        setValue('intTiposeguimiento', '');
        setValue('intIdtiporeporteseguimiento', '');
        const int_idtipoayudaddhh = ayudas.find(item => item.id === idAyuda).int_idtipoayudaddhh;
        setEsSeguimiento(int_idtipoayudaddhh == 4);
    }
    async function ObtenerVulnerabilidadesPorPersonaYModulo(idmodulo){
        if(!idmodulo){
            setVulnerabilidades([]);
            return;
        }
        const url = `/ddhh/atencionsddhh/obtenervulnerabilidades/${idCabezaFamilia}/${idmodulo}`;
        await apiService.get(url, token)
        .then(response => {
            const result = response.data;
            setVulnerabilidades(result.vulneraciones || []);
        })
        .catch(error => {
            Mensaje('Obtener vulnerabilidades', `Hubo un error con la carga de vulnerabilidades: ${error}`);
        });
    }
    const fetchData = useCallback(async (idCabezaFamilia, rol, user) => {
        const url = '/ddhh/atencionsddhh/crearformularioatencionsddhh';
        const obj = {idCabezaFamilia: idCabezaFamilia, usrRolid: rol, userId: user};
        setCargando(true);
        await apiService.post(url, obj, token)
        .then(response => {
            const result = response.data;
            setCabezaFamiliaDatos(result.cabezafamilia);
            setMotivosAtencion(result.motivosAtencion || []);
            setTiposSeguimiento(result.tiposSeguimiento || []);
            setEstadoCasos(result.estadoCasos || []);
            setModulosDdhh(result.modulosDdhh || []);
            setEntidades(result.entidades || []);
            setAyudas(result.ayudas || []);
            setIntegrantes(result.integrantesdto || []);
            setSedes(result.sedes || []);
            setTiposReporteSeguimiento(result.tiposReporteSeguimiento || []);
        })
        .catch(error => {
            Mensaje('Crear formulario', `Hubo un error con la carga de datos con el documento ${idCabezaFamilia}: ${error}`);
        })
        .finally(() => {
            setCargando(false);
            setValue('cabIdcabezafamilia', idCabezaFamilia);
        });
    }, [token, setValue]);

    const resetForm = useCallback((cleanList) => {
        const fechahoy = new Date();
        fechahoy.setHours(fechahoy.getHours() - 5);
        reset((prevValues) => ({
            ...prevValues,
            idatencion: "",
            atencion: "",
            idpersona: idCabezaFamilia,
            fecha: fechahoy,
            observaciones: "",
            idvulneracion: "",
            intModuloddhhid: "",
            usrId: user,
            sede: sedeActual,
            atencionesfields: cleanList ? [] : prevValues.atencionesfields,
            intMotivoatencion: '',
            intTiposeguimiento: '',
            intIdtiporeporteseguimiento: '',
            strConclusioncompromiso: '',
        }));
    }, [reset, sedeActual, user, idCabezaFamilia]);
    useEffect(() => {
        if (sedes.length > 0 && sedeActual) {
            setValue('sede', sedeActual);
        }
    }, [sedes, sedeActual, setValue]);
    useEffect(() => {
        fetchData(idCabezaFamilia, rol, user).then(() => {
            resetForm(true);
        });
    }, [idCabezaFamilia, rol, user, fetchData, resetForm]);
    
    const [searchTerm, setSearchTerm] = useState('');
    
    const handleSearch = (event) => {
        event.preventDefault();
        if (searchTerm.trim() !== '') {
            navigate(`/ddhh/atencionddhh/${searchTerm}`, { replace: true });
        }
    };
    const Mensaje = (title, text, tipo = 'info') => {
        const mensaje = `${title}: ${text}`;
        if (tipo === 'success') {
            toast.success(mensaje);
            return;
        }
        if (tipo === 'error') {
            toast.error(mensaje);
            return;
        }
        toast.info(mensaje);
    };
    const onSubmit = async (data) => {
        const esFallecido = integrantes.find((item) => item.per_idpersona === data.idpersona)?.per_fallecido;
        if(esFallecido === 'SI'){
            Mensaje('Registrar atencion', 'No se puede registrar atencion a un integrante fallecido', 'error');
            return;
        }
        const nombreayuda = ayudas.find((item) => item.id === data.atencion).atencion;
        const nombreSede = sedes.find((item) => item.id === data.sede).sedNombre;
        const nombreVulnerabilidad = vulnerabilidades.find((item) => item.id === data.vulnerabilidad)?.tipoVulneracion || '';
        append({
            idatencion: data.atencion, 
            atencion: nombreayuda, 
            idpersona: data.idpersona, 
            fecha: data.fecha,
            observaciones: data.observaciones,
            estadoCaso: data.estadoCaso,
            idvulneracion: data.vulnerabilidad,
            intModuloddhhid: data.intModuloddhhid,
            usrId: data.usrId,
            vulneracion: nombreVulnerabilidad,
            sede: nombreSede,
            intIdtiporeporteseguimiento: data.intIdtiporeporteseguimiento,
            sedeId: data.sede,
            intMotivoatencion: data.intMotivoatencion,
            intTiposeguimiento: data.intTiposeguimiento,
            strConclusioncompromiso: data.strConclusioncompromiso,
        });
        resetForm();
    };
    const GuardarAtenciones = async () => {
        const values = getValues();
        setCargando(true);
        let url;
        url = '/ddhh/atencionsddhh/registraroatencion';
        try {
            const response = await apiService.post(url, values, token);
            if(response.status === 200){
                Mensaje('Registrar atencion', JSON.stringify(response.data.message), 'success');
                resetForm(true);
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Registrar atencion', JSON.stringify(error.response.data.errors), 'error');
            }else if(error.status === 409){
                Mensaje('Registrar atencion', JSON.stringify(error.response.data), 'error');
            }else{
                Mensaje('Registrar atencion', `Hubo un error con el registro de la atencion: ${error}`, 'error');
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }

      };
    function Borraratencion (row){
        remove(getValues('atencionesfields').indexOf(row));
    };
    const columns = [
        {
            name: 'Acciones',
            cell: row => BorrandoAtencion(row, Borraratencion),
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'Atención', selector: row => row.atencion, sortable: true, width:'10%' },
        { name: 'Identificación', selector: row => row.idpersona, sortable: true, width: '15%'},
        { name: 'Vulneracion', selector: row => row.vulneracion, sortable: true, width: '15%'},
        { name: 'Observaciones', selector: row => row.observaciones, sortable: true, width: '55%' }
    ];
    return (
        <div className="content-wrapper">
            <SeccionPageHeader title="Registrar atenci&oacute;n" idCabezaFamilia={idCabezaFamilia} url={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} nombreurl="Grupo familiar" nombreform="Registrar atencion" />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div className="container-fluid">
                    <MenuCaracterizacion idCabezaFamilia={idCabezaFamilia} />
                    <SearchForm searchTerm={searchTerm} setSearchTerm={setSearchTerm} handleSearch={handleSearch} Cargando={Cargando} />
                    <div className="row">
                        {/* left column */}
                        <div className="col-md-12">
                            <div className="card card-info">
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                <DatosCabezaFamilia datos={CabezaFamiliaDatos} />
                                <input hidden {...register('usrId')}/><input hidden {...register('cabIdcabezafamilia')}/>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="intModuloddhhid">Linea de vulnerabilidad</label>
                                            <select id="intModuloddhhid" className="form-control" 
                                                {...register('intModuloddhhid', {
                                                    onChange: (e) => {
                                                        ObtenerVulnerabilidadesPorPersonaYModulo(e.target.value);
                                                    }
                                                }, { required: true })}>
                                                <option value="">Seleccione...</option>
                                                {modulosDdhh.map((option, idx) => (
                                                    <option key={option.id || idx} value={option.id}>{option.str_nombre}</option>
                                                ))}
                                            </select>
                                            {errors.intModuloddhhid && <span className="text-danger">Este campo es obligatorio</span>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='vulnerabilidad'>Vulneraci&oacute;n:</label>
                                            <select 
                                                id='vulnerabilidad' 
                                                {...register('vulnerabilidad', { required: true })} 
                                                className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {vulnerabilidades.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.tipoVulneracion} - {option.dat_fechahecho} - {option.nombrepersona}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.vulnerabilidad && <p style={{color: 'red'}}>Seleccione vulnerabilidad</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='idpersona'>Persona:</label>
                                            <select 
                                                id='idpersona' 
                                                {...register('idpersona', { required: true })} 
                                                className='form-control' >
                                                {integrantes.map((option) => (
                                                <option key={option.per_idpersona} value={option.per_idpersona}>
                                                    {option.par_parentesco} {option.per_idpersona} {option.nombre} {option.per_fallecido === 'SI' ? '(Fallecido)' : ''}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.idpersona && <p style={{color: 'red'}}>Seleccione integrante</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='atencion'>Atenci&oacute;n:</label>
                                            <select 
                                                id='atencion' 
                                                {...register('atencion', {
                                                    onChange: (e) => {
                                                        ValidarSiEsSeguimiento(e.target.value);
                                                    }
                                                }, { required: true })} 
                                                className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {ayudas.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.atencion}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.atencion && <p style={{color: 'red'}}>Seleccione atencion</p>}
                                        </div>
                                    </div>
                                    {esSeguimiento && (
                                        <div className="col-md-4">
                                            <div className="form-group" >
                                                <label htmlFor='intIdtiporeporteseguimiento'>Tipo reporte seguimientos:</label>
                                                <select id='intIdtiporeporteseguimiento' {...register('intIdtiporeporteseguimiento', { required: true })} className='form-control' >
                                                    <option value="">Seleccionar</option>
                                                    {tiposReporteSeguimiento.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.strNombre}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.intIdtiporeporteseguimiento && <p style={{color: 'red'}}>Seleccione tipo reporte seguimiento</p>}
                                            </div>
                                        </div>
                                    )}
                                    {esSeguimiento && (
                                        <div className="col-md-4">
                                            <div className="form-group" >
                                                <label htmlFor='intTiposeguimiento'>Tipo de Seguimiento</label>
                                                <select id='intTiposeguimiento' {...register('intTiposeguimiento', { required: true })} className='form-control' >
                                                    <option value="">Seleccionar</option>
                                                    {tiposSeguimiento.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.strNombre}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.intTiposeguimiento && <p style={{color: 'red'}}>Seleccione tipo seguimiento</p>}
                                            </div>
                                        </div>
                                    )}
                                    {!esSeguimiento && (
                                        <div className="col-md-4">
                                            <div className="form-group" >
                                                <label htmlFor='intMotivoatencion'>Motivo de Atenci&oacute;n</label>
                                                <select id='intMotivoatencion' {...register('intMotivoatencion', { required: true })} className='form-control' >
                                                    <option value="">Seleccionar</option>
                                                    {motivosAtencion.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.strNombre}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.intMotivoatencion && <p style={{color: 'red'}}>Seleccione motivo de atención</p>}
                                            </div>
                                        </div>
                                    )}
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='sede'>Sede:</label>
                                            <select id='sede' {...register('sede', { required: true })} className='form-control' readOnly={true}>
                                                {sedes.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.sedNombre}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.sede && <p style={{color: 'red'}}>Seleccione sede</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                                                <label htmlFor='fecha'>Fecha atenci&oacute;n</label>
                                                <Controller
                                                    id="fecha"
                                                    control={control}
                                                    name="fecha"
                                                    render={({ field }) => (
                                                        <DatePicker
                                                        placeholderText="fecha"
                                                        onChange={(date) => field.onChange(date)}
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        selected={field.value}
                                                        customInput={<CustomInput />}
                                                        locale="es"
                                                        dateFormat="yyyy-MM-dd"
                                                        maxDate={new Date()}
                                                        />
                                                    )}
                                                />
                                                {errors.fecha && <p style={{color: 'red'}}>Digite fecha de atencion</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='estadoCaso'>Estado Casos:</label>
                                            <select id='estadoCaso' {...register('estadoCaso', { required: true })} className='form-control'>
                                                {estadoCasos.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.str_nombre}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.estadoCaso && <p style={{color: 'red'}}>Seleccione estado de caso</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="observaciones">Observaciones</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('observaciones', { required: true })}
                                                placeholder="Observaciones"
                                            />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="strConclusioncompromiso">Conclusiones y Compromisos</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('strConclusioncompromiso', { required: true })}
                                                placeholder="Conclusiones y Compromisos"
                                            />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <button type="submit" className="btn btn-primary">Agregar</button>
                                    </div>
                                </div>
                                </div>
                                
                            </form>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className="card-body table-responsive p-0">
                                        <DataTable
                                            title="Atenciones"
                                            columns={columns}
                                            data={getValues('atencionesfields')}    
                                            progressPending={Cargando}
                                            pagination
                                            noDataComponent="No hay datos para mostrar"
                                        /> 
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <button type="button" onClick={GuardarAtenciones} className="btn btn-primary">Guardar</button>
                            </div>
                        </div>
                        {/* /.card */}

                        </div>
                        {/*/.col (left) */}

                    </div>
                    {/* /.row */}
                </div>{/* /.container-fluid */}
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}